import React from 'react';
import PopupInjector from '@src/components/Popup/PopupInjector';
import SettingsPopup from '@src/components/_layouts/Default/components/settings/SettingsPopup';

export default function Settings(props: {
    children: (...args: Parameters<React.ComponentProps<typeof PopupInjector>['renderButton']>) => React.ReactNode,
}) {
    return <PopupInjector
            popupName="user-settings-popup"
            renderPopup={props => <SettingsPopup {...props}/>}
            renderButton={props.children}
    />;
}
